// extracted by mini-css-extract-plugin
export default {"def-style":"styles_def-style__Fd31j","margin-bottom12":"styles_margin-bottom12__RjLiJ","txt-uppercase":"styles_txt-uppercase__LoV1M"};